"use client";

import type { Locale } from "@commerce-frontend/i18n/types";
import { useAddToCartContext } from "~/components/AddToCartContext";
import { useAddLineItems } from "~/hooks/cart/useAddLineItems";
import { ProductAddedToCartModal } from "./ProductAddedToCartModal";

type Props = {
	locale: Locale;
};

export function ProductAddedToCartModalIntegration({ locale }: Props) {
	const { addedLineItem } = useAddToCartContext();
	const { mutateAsync: addLineItems } = useAddLineItems();

	return (
		<ProductAddedToCartModal
			locale={locale}
			onAddVariant={(sku) =>
				addLineItems({
					lineItems: [{ sku, quantity: 1 }],
				}).then((r) => r.data?.cartLineItemsAdd.lineItems.find((l) => l.id === addedLineItem?.id))
			}
		/>
	);
}
